module.exports = __webpack_public_path__ + "_assets/img/bg_minigame.62e2a837.png";